import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

// Create a global variable to track script execution
if (typeof window !== 'undefined') {
    window.__SCRIPT_EXECUTED__ = window.__SCRIPT_EXECUTED__ || false;
}

const Seo = ( data ) => {

    // Configuration data query
    const config = useStaticQuery(graphql`
        query {
            site_configuration: storyblokEntry(field_component: {eq: "Site Configuration"}) {
                content
            }
        }
    `)

    // First use initial data, then the preview mode data
    const jsonPreview = data?.previewData || JSON.parse(config?.site_configuration?.content);

    // Add ref to track script execution

    // Execute Storyblok script
    useEffect(() => {
        if (typeof window !== 'undefined' && 
            jsonPreview?.scripts && 
            !window.__SCRIPT_EXECUTED__) {
            
            const script = document.createElement('script');
            script.textContent = jsonPreview.scripts;
            document.body.appendChild(script);
            window.__SCRIPT_EXECUTED__ = true;
        }
    }, [jsonPreview?.scripts]);

    const siteUrl = (jsonPreview.site_url || '').replace(/\/$/, '');
    const canonicalPath = data.url ? (data.url.endsWith('/') ? data.url : data.url + '/') : '';

    return (
        <Helmet>

            <html lang={data.en === true ? 'en' : jsonPreview.site_language} />
            <meta property="og:locale" content={data.en === true ? 'en' : jsonPreview.site_language} />

            {data.title && <title>{data.title}</title> }

            {data.title && <meta name="title" content={`${data.title}`} /> }
            {data.title && <meta property="og:title" content={`${data.title}`} /> }
            {data.title && <meta property="twitter:title" content={`${data.title}`} /> }

            <style>
            {`
                :root {
                    --background-color: ${jsonPreview?.background_color?.color};
                    --background-color-alternative: ${jsonPreview?.background_color_alternative?.color};
                    --paragraph-color: ${jsonPreview?.paragraph_color?.color};
                    --less-important-text-color: ${jsonPreview?.less_important_text_color?.color};
                    --title-color: ${jsonPreview?.title_color?.color};
                    --link-color: ${jsonPreview?.link_color?.color};
                    --link-hover-color: ${jsonPreview?.link_hover_color?.color};
                    --highlight-color: ${jsonPreview?.highlight_color?.color};
                    --highlight-color-2: ${jsonPreview?.highlight_color_2?.color};
                    --button-background-color: ${jsonPreview?.button_background_color?.color};
                    --button-text-color: ${jsonPreview?.button_text_color?.color};
                }
            `}
            </style>

            {jsonPreview?.googleAnalyticsId &&
                <script async src={`https://www.googletagmanager.com/gtag/js?id=${jsonPreview?.googleAnalyticsId}`} />
            }

            {jsonPreview?.googleAnalyticsId &&
                <script>
                    {`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());

                        gtag('config', '${jsonPreview?.googleAnalyticsId}');
                    `}
                </script>
            }

            <meta property="og:site_name" content={jsonPreview.site_name} />

            <meta property="twitter:card" content="summary_large_image" />

            <script async defer src="/scripts/table-sort.js"></script>

            {data.url && <link rel="canonical" href={`${siteUrl}${canonicalPath}`} />}

            {data.url && <meta property="og:url" content={`${siteUrl}${canonicalPath}`} /> }
            {data.url && <meta property="twitter:url" content={`${siteUrl}${canonicalPath}`} /> }

            {data.noindex === true && <meta name="robots" content="noindex" />}

            {data.type && <meta property="og:type" content={data.type} /> }

            {data.thumbnail && <meta property="og:image" content={data.thumbnail} /> }
                {data.thumbnail === "" && <meta property="og:image" content={jsonPreview.site_default_meta_thumbnail?.filename} />}
            {data.thumbnail && <meta property="twitter:image" content={data.thumbnail} /> }
                {data.thumbnail === "" && <meta property="twitter:image" content={jsonPreview.site_default_meta_thumbnail?.filename} /> }

            {data.description && <meta name="description" content={data.description} /> }
            {data.description && <meta property="og:description" content={data.description} /> }
            {data.description && <meta property="twitter:description" content={data.description} />}

            {/* {data.alternateSlug &&
                <link data-react-helmet="true" rel="alternate" hreflang={data.en === true ? 'en' : jsonPreview.site_language} href={`${jsonPreview.site_url}${data.url}`} />
            }

            {data.alternateSlug &&
                <link data-react-helmet="true" rel="alternate" hreflang={data.en === true ? jsonPreview.site_language : 'en'} href={`${jsonPreview.site_url}${data.alternateSlug}`} />
            } */}

            <link rel="icon" type="image/png" sizes="32x32" href={jsonPreview.site_favicon?.filename} />

        </Helmet>
    )
}

export default Seo